const is_valid_email = (email) => {
  return !!email.match("\\S+@\\S+\\.\\S+");
};

export default is_valid_email;
